import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=4965dbba&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4965dbba')) {
      api.createRecord('4965dbba', component.options)
    } else {
      api.reload('4965dbba', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=4965dbba&", function () {
      api.rerender('4965dbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25VvQ4XLo07p7/JS/comp/FavElement.vue"
export default component.exports